import { render, staticRenderFns } from "./crm-create-and-column-settings.vue?vue&type=template&id=cc0f8e44&scoped=true&"
import script from "./crm-create-and-column-settings.vue?vue&type=script&lang=js&"
export * from "./crm-create-and-column-settings.vue?vue&type=script&lang=js&"
import style0 from "./crm-create-and-column-settings.vue?vue&type=style&index=0&id=cc0f8e44&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc0f8e44",
  null
  
)

export default component.exports